import React from 'react'
import cx from 'classnames'
import Icon, { EIconId } from '../icons'

const TextLink: React.FC<{
  text: string
  styles?: React.CSSProperties
  className?: string
  onClick?: () => void
  href?: string
  bold?: boolean
  id?: string
}> = (props) => {
  const ElementType: React.ElementType = props.href ? 'a' : 'div'
  return (
    <ElementType
      id={props.id}
      onClick={props.onClick}
      className={cx(props.className, 'relative pr-32 text-16')}
      href={props.href}
    >
      <span className={cx('border-b leading-24', { 'font-bold': props.bold })} style={props.styles}>
        {props.children || props.text}
      </span>
      <Icon id={EIconId.ARROW_RIGHT} className="absolute right-0 w-20 h-20 -translate-y-1/2" style={{ top: '50%' }} />
    </ElementType>
  )
}

export default TextLink
